import React ,{ useState} from   "react";
import { View,
         StyleSheet,  
         TouchableOpacity, 
         ImageBackground, 
       Image 
} from "react-native";
//import { Image } from "react-native-expo-image-cache";
import colors from "../../config/colors";
import { Video, AVPlaybackStatus } from 'expo-av';
import ImageViewer from 'react-native-image-zoom-viewer'


function ListImageItem({imageUrl}) {
const [status, setStatus] = useState({});
 console.log('ejemplo de ->', imageUrl)
  return (

      <View style={styles.card}>
            {
                   imageUrl.includes('.mp4') ?
                   <Video 
                  // ref = {video}
                   style = {styles.image}
                   source = {{
                     uri: imageUrl
                   }}
                   useNativeControls
                   resizeMode = "contain"
                   isLooping
                   onPlaybackStatusUpdate = {status => setStatus(() => status)}
                   /> 
                   :imageUrl.includes('mov') ? 
                   <Video 
                  // ref = {video}
                   style = {styles.image}
                   source = {{
                     uri: imageUrl
                   }}
                   useNativeControls
                   resizeMode = "contain"
                   isLooping
                   onPlaybackStatusUpdate = {status => setStatus(() => status)}
                   /> 
                   :
                   
               <TouchableOpacity onPress={console.log('ejemplo de ->')}  style={styles.image}> 

                  <Image 
                    style={styles.image}
                    //  style={styles.image}
                    tint="light"
                    //preview={{ uri: imageUrl }}
                    source={{ uri: imageUrl }}
                    uri={imageUrl}
                    resizeMode="stretch"              
                />
              {/* <ImageViewer imageUrls={[{url: imageUrl}]} style={styles.image} renderIndicator={() => null} /> */}
              </TouchableOpacity> 
            }
          
    
      </View>

  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    flex : 1,
    backgroundColor: colors.green,
    // backgroundColor: colors.white,
    // marginBottom: 20,
    //overflow: "hidden",
  },
  image: {
    width:400,//'100%',
    height:'100%',
  },

});

export default  ListImageItem